// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExcessContributionFormResponseDto
 */
export interface IExcessContributionFormResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IExcessContributionFormResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IExcessContributionFormResponseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IExcessContributionFormResponseDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IExcessContributionFormResponseDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IExcessContributionFormResponseDto
     */
    excess_earnings?: number;
    /**
     * 
     * @type {number}
     * @memberof IExcessContributionFormResponseDto
     */
    payment_method_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExcessContributionFormResponseDto
     */
    file_url?: string;
    /**
     * 
     * @type {Date}
     * @memberof IExcessContributionFormResponseDto
     */
    created_at?: Date;
}

/**
 * Check if a given object implements the IExcessContributionFormResponseDto interface.
 */
export function instanceOfIExcessContributionFormResponseDto(value: object): value is IExcessContributionFormResponseDto {
    return true;
}

export function IExcessContributionFormResponseDtoFromJSON(json: any): IExcessContributionFormResponseDto {
    return IExcessContributionFormResponseDtoFromJSONTyped(json, false);
}

export function IExcessContributionFormResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExcessContributionFormResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'excess_earnings': json['excess_earnings'] == null ? undefined : json['excess_earnings'],
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IExcessContributionFormResponseDtoToJSON(json: any): IExcessContributionFormResponseDto {
    return IExcessContributionFormResponseDtoToJSONTyped(json, false);
}

export function IExcessContributionFormResponseDtoToJSONTyped(value?: IExcessContributionFormResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'employee_id': value['employee_id'],
        'claim_id': value['claim_id'],
        'amount': value['amount'],
        'excess_earnings': value['excess_earnings'],
        'payment_method_id': value['payment_method_id'],
        'file_url': value['file_url'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

